<script>
  // Logged-in users have no standalone home page -- the side menu is the
  // navigation. Landing on "/" sends them straight to Captures so the app
  // shell never renders with an empty body behind the old Welcome screen.
  import { onMount } from 'svelte';
  import { navigate } from 'svelte-routing';
  onMount(() => navigate('/captures', { replace: true }));
</script>
